import { Component, cloneElement } from 'react'

import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import Icon from 'components/Core/Icon/Icon'

import styles from './SummaryPopup.module.css'

class SummaryPopup extends Component {
  state = {
    popUpOpen: false,
    sticky: false,
  }

  onTrigger = (popUpOpen) => {
    if (this.state.sticky) {
      return
    }
    this.setState({ popUpOpen })
  }

  onSticky = (e, newValue) => {
    e.stopPropagation()

    this.setState({
      sticky: newValue,
      popUpOpen: newValue,
    })
  }

  render() {
    const { popUpOpen, sticky } = this.state

    const { trigger, children, className, header } = this.props

    const triggerExtraProps = {
      onMouseEnter: !sticky ? () => this.onTrigger(true) : null,
      onMouseLeave: !sticky ? () => this.onTrigger(false) : null,
      onClick: (e) => this.onSticky(e, true),
    }

    // We add extra props to the components we receive as props
    const triggerElement = cloneElement(trigger, triggerExtraProps)

    if (!popUpOpen) {
      return triggerElement
    }

    const headerExtraProps = {
      onClose: (e) => this.onSticky(e, false),
    }

    const headerElement = header ? cloneElement(header, headerExtraProps) : null

    return (
      <>
        {triggerElement}
        <div className={classNames(className, styles.SummaryPopup)}>
          {headerElement}
          {children}
        </div>
      </>
    )
  }
}

const Header = ({ children, className, onClose }) => (
  <div className={classNames(className, styles.Header)}>
    {children}
    <Icon name="close-x" className={styles.icon} onClick={onClose} />
  </div>
)

// TODO (jfernandez): make element an object to receive extra class names like 'notranslate'
const Body = ({ content, className, columnClassName, noTranslate = true }) => (
  <div className={classNames(className, styles.Body)}>
    {content.map((elements) => (
      <div key={`row_${elements[0]}`} className={styles.row}>
        {elements.map((element) => (
          <div
            key={`column_${element}`}
            className={classNames(columnClassName, styles.column, {
              notranslate: noTranslate,
            })}
          >
            {element}
          </div>
        ))}
      </div>
    ))}
  </div>
)

SummaryPopup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  trigger: PropTypes.node.isRequired,
  header: PropTypes.node,
}

SummaryPopup.defaultProps = {
  className: '',
  children: null,
  header: null,
}

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
}

Header.defaultProps = {
  className: '',
  children: null,
  onClose: null,
}

Body.propTypes = {
  className: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.array),
  columnClassName: PropTypes.string,
}

Body.defaultProps = {
  className: '',
  content: [],
  columnClassName: '',
}

SummaryPopup.Header = Header
SummaryPopup.Body = Body

export default SummaryPopup
